<template>
	<header id='head_top'>

		<section class="title_head ellipsis" v-if="headTitle">
			<span class="title_text">{{headTitle}}</span>
		</section>

		<section class="head_goback" v-if="goBack" @click="backClick">
			<van-icon name="arrow-left" class="svg_a"/>
			<!-- <svg-icon icon-class="back" class="svg_a"></svg-icon> -->
		</section>

		<section class="head_right" v-if="right_icon" @click="rightClick">
			<img :src="right_icon" class="right_icon" />
		</section>

	</header>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		mounted() {

		},
		props: ['headTitle', 'goBack', 'backPage', "right_icon"], //backPage 返回前面多少页
		computed: {

		},
		methods: {
			backClick() {
				//console.log("backClick>>>>>>>>>>>>>>>>>>>>>>>>>>>",window.history.length)
				if (window.history.length <= 1) {
					this.$router.push({
						path: '/'
					})
					return false
				} else {
					this.backPage ? this.$router.go(this.backPage) : this.$router.go(-1)
					//this.$router.go(-1)
				}
			},
			rightClick() {
				this.$emit('rightclick')
			}
		},

	}
</script>

<style scoped>
	.svg_a {
		width: 30px;
		height: 30px;
		line-height: 30px;
		padding-left: 10px;
		font-weight: bold;
		color: #FFF;
		font-size: 18px;
	}

	.right_icon {
		height: 28px;
		line-height: 28px;
		padding-right: 10px;
		padding-top: 10px;
	}

	#head_top {
		background-color: #3078FC;
		position: fixed;
		z-index: 999;
		left: 0;
		top: 0;
		width: 100%;
		height: 48px;
		display: flex;
	}

	.head_goback {
		width: 100%;
		line-height: 48px;
		height: 48px;
		position: absolute;
		text-align: left;
		display: flex;
		justify-content: flex-start;
		align-items: center;
	}

	.head_right {
		width: 100%;
		line-height: 48px;
		height: 48px;
		position: absolute;
		text-align: right;
	}

	.title_head {
		color: #fff;
		text-align: center;
		position: absolute;
		width: 100%;
		text-align: center;
		height: 48px;
		line-height: 48px;
	}

	.title_text {
		text-align: center;
		font-weight: bold;
		color: #FFF;
		font-size: 18px;
	}
</style>
